import type { ReactNode } from 'react';

import './MetaTile.scss';

/** Пропсы плитки «подпись + значение» MetaTile. */
export interface MetaTileProps {
  /** Подпись — верхняя строка (uppercase, серый) */
  label: string;
  /** Значение — нижняя строка (полужирная) */
  value: ReactNode;
  className?: string;
}

/**
 * Плитка «подпись + значение» для панелей сводки (серый прямоугольник).
 * Выделено из мастера ШМ (tfw-meta) в коллекцию ui.
 */
const MetaTile = ({ label, value, className }: MetaTileProps) => (
  <div className={ `meta-tile${ className ? ` ${ className }` : '' }` }>
    <span>{ label }</span>
    <strong>{ value }</strong>
  </div>
);

export default MetaTile;
